module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-white content-padded"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_c('h3', [_vm._v(_vm._s(_vm.resourceName) + "添加")])]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "maxlength": 10,
      "placeholder": "请输入名称"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属门店",
      "prop": "shopId"
    }
  }, [(_vm.form.resourceLevelId) ? _c('el-select', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.form.shopId),
      callback: function($$v) {
        _vm.$set(_vm.form, "shopId", $$v)
      },
      expression: "form.shopId"
    }
  }, _vm._l((_vm.storeData), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1) : _c('el-select', {
    model: {
      value: (_vm.form.shopId),
      callback: function($$v) {
        _vm.$set(_vm.form, "shopId", $$v)
      },
      expression: "form.shopId"
    }
  }, _vm._l((_vm.storeData), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "服务项目",
      "prop": "materialIds"
    }
  }, [_c('div', {
    staticClass: "server-box"
  }, [_c('div', {
    staticClass: "server-head clearfix"
  }, [_c('span', {
    staticClass: "f_l"
  }, [_vm._v("服务目录(" + _vm._s(_vm.serverList.length) + "项)")]), _c('div', {
    staticClass: "f_r"
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.checkAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")])], 1)]), _vm._v(" "), _c('el-checkbox-group', {
    staticClass: "server-list",
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.form.materialIds),
      callback: function($$v) {
        _vm.$set(_vm.form, "materialIds", $$v)
      },
      expression: "form.materialIds"
    }
  }, [_c('el-row', _vm._l((_vm.serverList), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 6,
        "title": item.label
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.label))])], 1)
  }), 1)], 1)], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "简介",
      "prop": "description"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "resize": "none",
      "maxlength": 100
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v(_vm._s(_vm.form.description.length) + " / 100")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示图"
    }
  }, [_c('div', [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": _vm.handleImgChange
    }
  }, [(_vm.form.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.wximageurl + _vm.form.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveResource
    }
  }, [_vm._v("保存")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0b6f1509", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b6f1509"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/reservation/resourcesetting/add.vue
// module id = 2455
// module chunks = 0